import SearchIcon from "@mui/icons-material/Search";
import { Card, Grid } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import { AccountContext } from "context/account";
import qs from "query-string";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "services/api";
import BlogCard from "./blogcard";
import BlogEditor, { blogLabelConfigs } from "./blogeditor";
import BlogViewer from "./blogviewer";
import UserBlogs from "./userblogs";
import NewBlogCard from "pages/de/dashboard/components/NewBlogCard";
import { Empty } from "antd";

export default function Blog() {
  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const account = useContext(AccountContext);
  let userid = urlObj?.query.userid;
  if (userid) return <UserBlogs userid={userid} />;
  let viewblogid = urlObj?.query.viewblogid;
  if (viewblogid) return <BlogViewer viewblogid={viewblogid} />;
  let editblogid = urlObj?.query.editblogid;
  if (editblogid) return <BlogEditor blogid={editblogid} />;
  let create = urlObj?.query.create;
  if (create == "1") return <BlogEditor />;
  let myblog = urlObj?.query.myblog;
  if (myblog == "1") return <UserBlogs />;

  let inputLabelFilter = urlObj?.query.label;
  const [blogsData, setBlogsData] = useState([]);
  const [filteredBlogsData, setFilteredBlogsData] = useState([]);
  const [labelFilter, setLabelFilter] = useState(
    inputLabelFilter ? { label: inputLabelFilter, value: inputLabelFilter } : null
  );
  const [searchStr, setSearchStr] = useState("");

  useEffect(() => {
    setLabelFilter(inputLabelFilter ? { label: inputLabelFilter, value: inputLabelFilter } : null);
  }, [inputLabelFilter]);

  const filter = (blogs) => {
    var tmpblogsData = blogs;
    if (labelFilter)
      tmpblogsData = tmpblogsData.filter((b) => b.labels?.includes(labelFilter.value));
    if (searchStr != "")
      tmpblogsData = tmpblogsData.filter(
        (b) =>
          b.title?.toLowerCase().includes(searchStr) ||
          b.summary?.toLowerCase().includes(searchStr) ||
          b.username?.toLowerCase().includes(searchStr)
      );
    setFilteredBlogsData(tmpblogsData);
  };

  const reload = () => {
    try {
      api.blog.homepage().then(({ data }) => {
        setBlogsData(data.blogs);
        filter(data.blogs);
        //console.log('data.blogs', data.blogs)
        return data;
      });
    } catch (err) {
      toast.error(`getuserblogs failed!`);
      console.log(err);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  useEffect(() => {
    filter(blogsData);
  }, [labelFilter, searchStr]);

  return (
    <SuiBox p={2}>
      <SuiBox className="justify-between" display="flex" alignItems="center">
        {/* <SuiTypography variant="h5" fontWeight="medium">
        {"Homepage"}
      </SuiTypography> */}
        {account.id == "UpStyled" && (
          <SuiButton component={Link} to={`/social/blog?myblog=1`} variant="outlined" color="dark">
            My Blogs
          </SuiButton>
        )}
      </SuiBox>
      <SuiBox display="flex" alignItems="center" justifyContent="space-between" mt={2} mb={2}>
        <SuiBox>
          {" "}
          <SuiBox display="flex" alignItems="center" gap={2}>
            <SuiTypography variant="button" fontWeight="regular">
              Filter by:
            </SuiTypography>
            <Card sx={{ borderRadius: 2 }}>
              <SuiSelect
                options={blogLabelConfigs}
                placeholder="Select label to filter"
                isClearable
                onChange={setLabelFilter}
                value={labelFilter}
              />
            </Card>
          </SuiBox>
        </SuiBox>
        <SuiBox>
          <SuiInput
            placeholder="Search Keywords"
            type="text"
            onChange={(e) => setSearchStr(e?.target?.value.toLowerCase())}
            icon={{
              direction: "right",
              component: (
                <SearchIcon sx={{ cursor: "pointer" }} onClick={() => setSearchStr(searchStr)} />
              ),
            }}
          />
        </SuiBox>
      </SuiBox>
      <SuiBox
        display="flex"
        overflow="auto"
        gap={1}
        p={1}
        sx={{
          alignItems: "stretch",
        }}
      >
        {filteredBlogsData.length > 0 ? (
          filteredBlogsData.map((blog, index) => (
            <SuiBox sx={{ width: 320, minWidth: 320, m: 1 }}>
              <NewBlogCard blog={blog} index={index} refreshParent={reload} />
            </SuiBox>
          ))
        ) : (
          <div style={{ width: "100%" }}>
            <Empty description={null} />
          </div>
        )}
      </SuiBox>
    </SuiBox>
  );
}
